import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from 'react/components/Tabs';
import Tab from 'react/components/navigation/Tab';
import TransactionsComponent from 'react/components/TransactionsComponent';
import DuplicateTransactions from 'react/components/duplicateTransactions/DuplicateTransactions';
import UnbudgetedBankRecords from 'react/components/unbudgetedBankRecords/UnbudgetedBankRecords';
import { transactionsViewChanged, transactionsViews } from 'redux/actions/url';

/**
 * The Transactions section: the month's transactions, a Duplicates tab for cleaning up ones entered
 * twice across every month, and an Unbudgeted tab for bank records kept out of the budget. The tab
 * is in the url, /dashboard/transactions/duplicates or /unbudgeted. Every prop is the transactions
 * list's; the Duplicates tab takes only the delete and its undo.
 */
export default function TransactionsSection(props) {
	const dispatch = useDispatch();
	const view = useSelector((state) => state.url.transactionsView);

	return (
		<Tabs
			activeTab={view}
			onTabChange={(tab) => dispatch(transactionsViewChanged(tab))}
			tabsClasses='transactions_tabs'
		>
			<Tab label={transactionsViews.ALL} content='All'>
				<TransactionsComponent {...props} />
			</Tab>
			<Tab label={transactionsViews.DUPLICATES} content='Duplicates'>
				<DuplicateTransactions transactionDelete={props.transactionDelete} transactionDeleteUndo={props.transactionDeleteUndo} />
			</Tab>
			<Tab label={transactionsViews.UNBUDGETED} content='Unbudgeted'>
				<UnbudgetedBankRecords />
			</Tab>
		</Tabs>
	);
}
